import { useEffect, useState } from 'react';
import { getEmployeeOfMonth, GetEmployeeOfMonthOutputType } from 'zite-endpoints-sdk';
import { Link } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import { useAuth } from 'zite-auth-sdk';

type EOTM = GetEmployeeOfMonthOutputType['current'];

export default function EmployeeOfMonthBanner() {
  const { user } = useAuth();
  const [current, setCurrent] = useState<EOTM | null | undefined>(undefined);

  useEffect(() => {
    getEmployeeOfMonth({}).then(d => setCurrent(d.current)).catch(() => setCurrent(null));
  }, []);

  if (!current) return null;

  const isMe = current.employeeId === user?.id;

  return (
    <div className={`border rounded-xl p-4 flex items-center gap-4 ${isMe ? 'border-amber-500/40 bg-amber-500/5' : 'border-border bg-card'}`}>
      {current.photoUrl ? (
        <img src={current.photoUrl} alt={current.employeeName} className="w-14 h-14 rounded-full object-cover border-2 border-amber-500/40 shrink-0" />
      ) : (
        <div className="w-14 h-14 rounded-full bg-amber-500/15 flex items-center justify-center shrink-0">
          <Trophy className="w-7 h-7 text-amber-500" />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-amber-600 uppercase tracking-wider">🏆 Employee of the Month — {current.month}</p>
        <p className="text-base font-bold text-foreground mt-0.5">
          {isMe ? '🌟 That\'s you!' : current.employeeName}
        </p>
        {current.reason && <p className="text-xs text-muted-foreground mt-1 line-clamp-2">{current.reason}</p>}
      </div>
      <Link to="/employee-of-month" className="text-xs text-primary hover:underline shrink-0">Hall of Fame →</Link>
    </div>
  );
}
